<template>
  <div class="main-content">
    <div class="page-content">
      <!-- start page title -->
      <app-page-title title="Usuários" :breadcrumbs="breadcrumbs" />
      <!-- end page title -->
      <template v-if="items && teamsData && total">
        <template v-if="list">
          <user-list :items="items" :squads="teamsData" :total="total" @handle="handleUser" />
        </template>
        <template v-else>
          <user-form :selected="userData" :squads="teamsData" @handle="alterLayout()" />
        </template>
      </template>
    </div>
    <!-- End Page-content -->
  </div>
</template>
<script>
import AppPageTitle from "@/components/AppPageTitle/AppPageTitle.vue";
import UserList from "@/views/admin/users/List.vue";
import UserForm from "@/views/admin/users/Form.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    UserList,
    UserForm,
    AppPageTitle
  },
  data() {
    return {
      total: 0,
      items: null,
      teamsData: null,
      list: true,
      userData: {},
      breadcrumbs: [],
      breadcrumbsDefault: ["Configurações", "Usuários"]
    };
  },
  mounted() {
    this.breadcrumbs = this.breadcrumbsDefault;
    this.getUserBoards();
  },
  methods: {
    ...mapState(["users"]),
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    async getUserBoards() {
      try {
        const response = await this.$AppCallApi("GET", "user");
        if (response.data) {
          this.total = response.data.data.total;
          this.items = response.data.data.data.user;
          this.teamsData = response.data.data.data.teams;
          console.log(response.data)
        } else {
          console.log(response)
          //this.showBlockScreen(true);
          //this.$router.push("/login");
        }
      } catch (error) {
        this.showMessage({
          title: error.response.data.message,
          text: this.$root.$options.filters.objectError(
            error.response.data.errors
          ),
          css: "bg-danger"
        });
      }
    },
    alterLayout() {
      this.list = !this.list;
      this.breadcrumbs = this.list === true
        ? this.breadcrumbsDefault
        : ["Configurações", "Usuário"];
    },
    handleUser(u) {
      if(u){
        this.userData = this.items.find(user => user.id === u);
      }else{
        this.userData = {};
      }
      this.alterLayout();
    }
  }
};
</script>
